document.addEventListener('DOMContentLoaded', () => {
  // Cibler tous les liens de changement de langue connus
  const langLinks = document.querySelectorAll('a[href="/"], a[href^="/fr"], a[href^="/en"]');

  langLinks.forEach(link => {
    // Utilise mousedown pour capturer AVANT le changement de page
    link.addEventListener('mousedown', () => {
      localStorage.setItem('lang_selected', 'manual');
    });

    // En fallback pour certains navigateurs
    link.addEventListener('click', () => {
      localStorage.setItem('lang_selected', 'manual');
    });
  });
});

